var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "firma-dialog-container" },
    [
      _c("CustomDialogHeaderComponent", {
        attrs: { headerTitle: _vm.texts.title },
      }),
      _c("p", { staticClass: "explanation" }, [
        _vm._v(_vm._s(_vm.texts.explanation)),
      ]),
      _c("CustomDialogActionButtonsComponent", {
        attrs: {
          disabledButtons: false,
          mainAction: _vm.signFirma,
          primaryButtonText: _vm.texts.primaryButtonText,
        },
      }),
      _vm.loadingSpinner
        ? _c("SpinnerLayerComponent", {
            staticClass: "spinner-layer",
            attrs: { loadingText: _vm.spinnerText.sending },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }